import { render, staticRenderFns } from "./orderStatistic.vue?vue&type=template&id=0c697876&scoped=true"
import script from "./orderStatistic.vue?vue&type=script&lang=js"
export * from "./orderStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c697876",
  null
  
)

export default component.exports